import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/base.css';
import './axiosSetup';
import { App } from './App';
import { bootstrapTenant, TenantBootResult } from './tenantBootstrap';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Minimal centered status screen for multi-tenant states that aren't "render
// the app" (provisioning / unknown subdomain / lookup error). Single-tenant
// builds (SixSigma/OBI/CCS) never reach these — bootstrapTenant returns
// { mode: 'single' } and we render <App /> immediately.
function StatusScreen({ title, detail }: { title: string; detail: string }) {
  return (
    <div style={{
      minHeight: '100vh', display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', textAlign: 'center',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      color: '#002628', padding: 24,
    }}>
      <div style={{ fontSize: 22, fontWeight: 800, color: '#008481' }}>CleanSpaces</div>
      <h1 style={{ fontSize: 26, margin: '16px 0 8px' }}>{title}</h1>
      <p style={{ color: '#707070', maxWidth: 420 }}>{detail}</p>
    </div>
  );
}

function renderFor(result: TenantBootResult) {
  if (result.mode === 'single' || result.status === 'ready') {
    return <App />;
  }
  switch (result.status) {
    case 'provisioning':
      return <StatusScreen
        title="Setting up your workspace…"
        detail="We're finishing provisioning this environment. This usually takes a few minutes. Check the email we sent, or refresh shortly." />;
    case 'notfound':
      return <StatusScreen
        title="Workspace not found"
        detail="We couldn't find a CleanSpaces workspace at this address. Check the link, or sign up to create one." />;
    default:
      return <StatusScreen
        title="Something went wrong"
        detail="We couldn't load this workspace right now. Please try again in a moment." />;
  }
}

bootstrapTenant().then((result) => {
  root.render(
    <React.StrictMode>
      <ErrorBoundary>{renderFor(result)}</ErrorBoundary>
    </React.StrictMode>
  );
});
